var _rect, _circle, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _circle2, _circle3, _ellipse, _ellipse2, _ellipse3, _path9, _ellipse4, _circle4, _ellipse5, _circle5, _path10, _path11, _path12, _path13, _path14, _circle6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlayerPortrait17(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 120,
    height: 120,
    fill: "#b7a4d9"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 60,
    cy: 60,
    r: 52,
    fill: "#bfaedd",
    opacity: 0.55
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34 48C32 22 48 18 60 18S88 22 86 48L87 76C87 82 81 84 76 82H44C39 84 33 82 33 76Z",
    fill: "#241c22"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 124C12 98 34 90 60 90S108 98 108 124Z",
    fill: "#2b3a5c"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12 96L108 96",
    stroke: "#f4f1ea",
    strokeWidth: 3.2,
    opacity: 0.9
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12 104L108 104",
    stroke: "#f4f1ea",
    strokeWidth: 3.2,
    opacity: 0.9
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12 112L108 112",
    stroke: "#f4f1ea",
    strokeWidth: 3.2,
    opacity: 0.9
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M12 120L108 120",
    stroke: "#f4f1ea",
    strokeWidth: 3.2,
    opacity: 0.9
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M46 86C48 94 72 94 74 86",
    fill: "none",
    stroke: "#222e49",
    strokeWidth: 2
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M52 70H68V92C66 96 54 96 52 92Z",
    fill: "#d8b99d"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 38,
    cy: 56,
    r: 5,
    fill: "#f6d3b3"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 82,
    cy: 56,
    r: 5,
    fill: "#f6d3b3"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 60,
    cy: 52,
    rx: 21,
    ry: 25,
    fill: "#f6d3b3"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 45,
    cy: 63,
    rx: 4,
    ry: 2.4,
    fill: "#e8806a",
    opacity: 0.3
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 75,
    cy: 63,
    rx: 4,
    ry: 2.4,
    fill: "#e8806a",
    opacity: 0.3
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M58.5 57Q56.5 62 59 63.5Q60 64 61.5 63.5",
    stroke: "#bfa48b",
    strokeWidth: 1.8,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 51,
    cy: 54,
    rx: 2.5,
    ry: 3,
    fill: "#2a1d1a"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 51.9,
    cy: 53,
    r: 0.9,
    fill: "#fff"
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 69,
    cy: 54,
    rx: 2.5,
    ry: 3,
    fill: "#2a1d1a"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 69.9,
    cy: 53,
    r: 0.9,
    fill: "#fff"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M46 48Q51 44 56 47",
    stroke: "#241c22",
    strokeWidth: 2.2,
    fill: "none",
    strokeLinecap: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M64 48Q69 44 74 47",
    stroke: "#241c22",
    strokeWidth: 2.2,
    fill: "none",
    strokeLinecap: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M52 68Q56 65 60 67Q64 65 68 68Q60 75 52 68Z",
    fill: "#c4303c"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M37 48C34 27 48 21 60 21S86 27 83 48L80 42C70 44 50 44 40 42Z",
    fill: "#241c22"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M30 36C28 20 46 12 66 14C84 16 92 26 86 36C78 42 42 44 30 36Z",
    fill: "#c8412b"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 64,
    cy: 12,
    r: 3,
    fill: "#a03422"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayerPortrait17);
export default __webpack_public_path__ + "static/media/player-portrait-17.872a83e5b5a349412f2292bd9aa0e13e.svg";
export { ForwardRef as ReactComponent };